import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import DatafabriqMark from "@webcore/components/core/DatafabriqMark/DatafabriqMark";

interface DatafabriqLogoProps {
  size?: "sm" | "lg";
  linkTo?: string;
}

const DatafabriqLogo: React.FC<DatafabriqLogoProps> = ({ size = "sm", linkTo = "/" }) => {
  const markDims = size === "lg" ? { w: 31, h: 28 } : { w: 26, h: 24 };

  return (
    <Link to={linkTo} className={classNames("cs-logo", { "cs-logo-lg": size === "lg" })}>
      <DatafabriqMark className="cs-logo-mark" width={markDims.w} height={markDims.h} />
      <span className="cs-logo-word">datafabr<span className="iq">iq</span></span>
    </Link>
  );
};

export default DatafabriqLogo;
